import SvgIcon from '@mui/material/SvgIcon';

export default function PlumSvg({ width, height }) {
  return (
    <SvgIcon sx={{ width: width, height: height }}>
      <svg id="Capa_1" enableBackground="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <g>
          <g>
            <g>
              <ellipse cx="292.902" cy="307.859" fill="#683983" rx="162.334" ry="196.64"/>
              <path d="m455.239 307.86c0 108.6-72.684 196.64-162.341 196.64-6.698 0-13.303-.488-19.794-1.452 80.305-11.83 142.526-94.707 142.526-195.188s-62.22-183.358-142.525-195.189c6.491-.964 13.096-1.452 19.794-1.452 89.657 0 162.34 88.04 162.34 196.641z" fill="#804d9e"/>
              <g>
                <g>
                  <g>
                    <path d="m269.011 157.371c-4.683-64.646-24.174-110.478-33.715-129.495-2.694-5.37-.267-11.89 5.276-14.206l12.878-5.379c5.225-2.182 11.247.223 13.506 5.415 21.411 49.212 26.96 108.973 26.149 143.137-.155 6.538-5.523 11.744-12.063 11.744-6.332 0-11.574-4.901-12.031-11.216z" fill="#bcea73"/>
                  </g>
                </g>
              </g>
            </g>
            <g>
              <ellipse cx="219.097" cy="307.859" fill="#ae6ad8" rx="162.334" ry="196.64"/>
              <g>
                <path d="m283.245 145.736c-85.872 46.514-133.06 32.578-158.992 2.52 26.678-23.309 59.432-37.037 94.841-37.037 18.02 0 35.357 3.557 51.553 10.13 9.426 13.335 12.598 24.387 12.598 24.387z" fill="#975bbb"/>
              </g>
              <path d="m381.436 307.86c0 108.6-72.684 196.64-162.341 196.64-8.948 0-17.73-.881-26.295-2.572 81.155-10.068 144.465-93.11 144.465-194.069s-63.31-184-144.465-194.068c8.564-1.69 17.347-2.572 26.295-2.572 89.657 0 162.341 88.04 162.341 196.641z" fill="#975bbb"/>
            </g>
            <g>
              <g>
                <g>
                  <path d="m270.578 120.116s-17.666-61.649-93.579-69.285c-37.156-3.738-61.175-10.961-76.016-17.363-9.797-4.226-20.474 3.838-19.025 14.408 7.078 51.67 39.629 152.934 188.62 72.24z" fill="#99d53b"/>
                </g>
                <g>
                  <path d="m270.582 120.115c-6.169 3.339-12.152 6.377-17.927 9.104-9.239-18.218-33.656-52.237-88.765-57.774-37.161-3.743-61.175-10.96-76.022-17.367-1.711-.747-3.453-1.099-5.153-1.13-.28-1.731-.529-3.432-.757-5.07-1.451-10.576 9.228-18.632 19.026-14.412 14.837 6.408 38.861 13.624 76.012 17.367 75.918 7.631 93.586 69.282 93.586 69.282z" fill="#82b732"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
}
